import { createSlice } from "@reduxjs/toolkit";
import {
  getAdminUserInfoBuilder,
  loginBuilder,
  logoutBuilder,
  refreshBuilder,
} from "./builder";

const initialState = {
  email: "",
  loggedIn: null,
  error: null,
  token: null,
  loginPending: false,
  getAdminUserInfoPending: false,
};

export const authSlice = createSlice({
  name: "authInfo",
  initialState,
  reducers: {
    setLoggedIn: (state, { payload }) => {
      state.loggedIn = payload.loggedIn;
    },
  },
  extraReducers: (builder) => {
    loginBuilder(builder);
    refreshBuilder(builder);
    logoutBuilder(builder);
    getAdminUserInfoBuilder(builder);

    builder.addCase("logout", () => ({ ...initialState, loggedIn: false }));
  },
});

export const { setLoggedIn } = authSlice.actions;

export const selectAdminUserInfo = (state) => state.authInfo;
export const selectLoggedIn = (state) => state.authInfo.loggedIn;
export const selectLoginPending = (state) => state.authInfo.loginPending;
export const selectGetAdminUserInfoPending = (state) =>
  state.authInfo.getAdminUserInfoPending;

export default authSlice.reducer;
